import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { intercept } from "./networking";
import App from "./App"
import "./axios";
import "./assets/css/modern-normalize.css";
import "./assets/css/misc.css";
import "./assets/css/style.css";
import "./assets/css/media.css";
import "./assets/css/sme.css";
import "./assets/css/toastify.css";

const store = configureStore();
intercept(store);

ReactDOM.render(
    <Provider store={store}>
        <Suspense fallback={null}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Suspense>
    </Provider>,
    document.getElementById("root"),
);
